import ListIcon from "@redotech/redo-icons/list.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.pickSessionIdValue;

export const PickSessionIdFilter: ArrayStringTableFilter<string> = {
  type: entry.type,
  itemLabel: "Session ID",
  operators: entry.operators,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: ListIcon,
  displayName: entry.displayName,
  dbSearch: true,
};
